// extracted by mini-css-extract-plugin
export default {"container":"SortArrow_container__iwpXr","up":"SortArrow_up__MGMYa"};